import React from 'react'
import PropTypes from 'prop-types'

import { useTheme } from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Dots, Heading } from 'Components/Blocks/_Legacy'
import { Border, Motion, Wrapper } from 'Components/UI'

import { ctoService2Image, iconGrammerlyGlyph } from 'Assets/_Legacy/CtoPage'

import {
  Container,
  Content,
  DotsContainer,
  ImageHolder,
  StyledImage,
} from './styles'

function Service({ data }) {
  const theme = useTheme()

  return (
    <>
      <Border bg={themeGet('colors.bg.primary')({ theme })} topRight />

      <Container>
        <Wrapper>
          <Content>
            <DotsContainer>
              <Dots
                columns={17}
                corners={[true, true, true, true]}
                margin={5}
                rows={18}
              />
            </DotsContainer>

            <ImageHolder mr={[0, 0, 0, 0, '120px']} mt={[11, 11, 11, 11, 0]}>
              <StyledImage
                alt="A smiling man in glasses and a light shirt working on a laptop at a desk in a bright office"
                src={ctoService2Image.src}
              />
            </ImageHolder>

            <Motion>
              {/* `as` was a dead prop on Heading (dropped by pick()) — the
                  title renders as the default h2; the page h1 is the Hero. */}
              <Heading
                fontSizes={{ title: [24, 24, 45], sub: [14, 14, 16] }}
                horizontalAlign="left"
                subTitleText={data?.serviceDescription}
                tagGlyph={iconGrammerlyGlyph}
                tagText={data?.serviceTagText}
                tagTextAs="h4"
                titleText={{
                  first: { text: data?.serviceTitleBold, bold: true },
                  second: { text: data?.serviceTitleRegular, bold: false },
                }}
              />
            </Motion>
          </Content>
        </Wrapper>
      </Container>
    </>
  )
}

Service.defaultProps = {
  data: {},
}

Service.propTypes = {
  data: PropTypes.object,
}

export default Service
